import { useHistory } from 'react-router'
import { useContext } from 'react'
import { Context } from '../../context/Provider'

import { AlignmentContainer } from '../../components/SharedContainers'
import { Icon, Space, Text, theme, Button, MainContainer } from 'verak-ui'
import { useFetch } from '../../api/apihook'

const StockInProcessCheck = () => {
	const fetch = useFetch()
	const [state, dispatch] = useContext(Context)
	let history = useHistory()

	const proceed = async value => {
		await new Promise((resolve, reject) => {
			dispatch({
				type: 'SET_STOCK_IN_PROCESS',
				data: {
					StockInProcess: value,
				},
			})
			resolve()
		})

		history.push('/stock-disclosure-choice/railway-sidings')
	}
	return (
		<MainContainer
			header="Let’s understand which Stock disclosure methods are applicable for the client"
			top={4}
		>
			<AlignmentContainer>
				<Space y={3.125} />
				<Icon name="processingStock" />
				<Space y={1.5} />
				<Text type="primary" color={theme.colors.gray7}>
					Does the client wish to insure any Stock in process?
				</Text>
				<Space y={1.5} />
				<div className="flex-container">
					<Button
						label="No"
						icon="no"
						iconStyles={iconStyle}
						style={buttonStyle}
						secondary
						onClick={() => proceed(false)}
					/>
					<Space x={1} />
					<Button
						label="Yes"
						icon="yes"
						iconStyles={iconStyle}
						style={buttonStyle}
						onClick={() => proceed(true)}
					/>
				</div>
				<Space y={1.5} />
				{/* Couldn't modify the alert component to create this */}
				<div className="flex-container">
					<Icon name="infoIconOctagon" color={theme.colors.secondary} />
					<Space x={0.5} />
					<Text style={{ fontSize: '14px', fontWeight: '700' }} color={theme.colors.secondary}>
						Stock in process refers to any unfinished goods - which are yet to undergo the further
						manufacturing prior to sale to end clients.{' '}
					</Text>
				</div>
			</AlignmentContainer>
		</MainContainer>
	)
}

export default StockInProcessCheck

const iconStyle = {
	marginRight: '0.5rem',
}
const buttonStyle = {
	width: '200px',
	height: '48px',
}
